import { css } from 'styled-components';

/**
 * Card control arrows (order preset, sub account, aggregation) only appear while the card is hovered,
 * so an idle card keeps its compact control row.
 *
 * hover (not any-hover): a touch tap can match :hover on a paired trackpad device and shift buttons mid-tap.
 */
export const hideNavigableControlArrowsUntilHover = css`
  @media (hover: hover) {
    &:not(:hover) {
      .order-presets-prev,
      .order-presets-next,
      .subaccount-prev,
      .subaccount-next,
      .aggregation-prev,
      .aggregation-next {
        display: none;
      }
    }
  }
`;
